// extracted by mini-css-extract-plugin
module.exports = {"context-menu-list-item":"context-menu-item_context-menu-list-item__1SIQg","is-disabled":"context-menu-item_is-disabled__MYe1o","is-danger":"context-menu-item_is-danger__24-xn"};